import React, { useState } from "react";
import Navbar from "../HomePage/header";
import SupportSection from "../HomePage/SupportSection";
import Footer from "../HomePage/footer";
import FaqSection from "./FaqSection";
import SignInForm from "../SignIn/SignInForm";
import CreateAccount from "../CreateAccount/CreateAccount";

const FAQs = ({ windowSize }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);
  const handleLoginOpen = (newState) => {
    setIsModalOpen(newState);
  };

  const handleCreateAccountOpen = (newState) => {
    setIsCreateAccountOpen(newState);
  };
  return (
    <div className=" bg-[#EFF3F5] p-4">
       <SignInForm
        open={isModalOpen}
        isLoginFormOpen={handleLoginOpen}
        isCreateAccountOpen={handleCreateAccountOpen}
      />
      <CreateAccount
        open={isCreateAccountOpen}
        isCreateAccountOpen={handleCreateAccountOpen}
        isLoginFormOpen={handleLoginOpen}
      />
      <div className="pt-8 mx-4">
        <Navbar isLoginFormOpen={handleLoginOpen} windowSize={windowSize} />
      </div>
      <FaqSection windowSize={windowSize} />
      <div className="container mx-auto">
        <SupportSection windowSize={windowSize} />
      </div>
      <Footer windowSize={windowSize} />
    </div>
  );
};

export default FAQs;
